import React from "react";
import { Trans, useTranslation } from "react-i18next";
import tw, { css } from "twin.macro";

import Cogs from "../../../../static/icons/cogs.svg";
import Diamond from "../../../../static/icons/diamond.svg";
import Puzzle from "../../../../static/icons/puzzle.svg";
import Card from "../../../components/Card";
import { getTranslationList } from "../../../utils/common";

const cardsStyle = css`
  > div {
    ${tw`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-5xl pt-8`}
  }
  > h2 {
    ${tw`text-5xl text-center font-black`}
  }
  .agencyP {
    ${tw`text-center `}  
  }
  .agency1 {
    ${tw`font-bold text-3xl mb-6`}  
  }
  .agency2 {
    ${tw`text-3xl`}  
  }
  .stageCard {
    ${tw`rounded-[4rem] md:h-96 text-turquoise hover:(text-turquoise-dark)hover:shadow-xl motion-safe:hover:scale-105`}  
    >div {
      ${tw``}
      >svg {
        ${tw``}
        >g {
          ${tw`stroke-current fill-current`}
        }
      }  
    }
  }
.preIconContent {
    ${tw`text-center text-3xl`}
  }
}
.stageCard {
  ${tw`hover:(text-turquoise-dark)`}
}
`;

const AgencyServicesCards: React.FC = () => {
  const { t } = useTranslation();
  const cardHeadres = getTranslationList(t, "AgencyServices.cardSection.cards.headers");
  const cardsContent = getTranslationList(t, "AgencyServices.cardSection.cards.content");
  const cardsRefs = getTranslationList(t, "AgencyServices.cardSection.cards.links");
  const icons = [<Diamond key="Diamond" />, <Puzzle key="Puzzle" />, <Cogs key="Cogs" />];

  return (
    <div css={cardsStyle}>
      <h2>{t("AgencyServices.header")}</h2>
      <p className="agency1 agencyP">{t("AgencyServices.question")}</p>
      <p className="agency2 agencyP">{t("AgencyServices.answer")}</p>
      <div>
        {cardHeadres.map((cardHeader, i) => (
          <a href={t(cardsRefs[i])} key={i}>
            <Card
              icon={icons[i]}
              className="stageCard"
              key={i}
              preIconContent={<Trans i18nKey={t(cardHeader)} components={{ bold: <strong />, br: <br /> }} />}
            >
              <Trans i18nKey={t(cardsContent[i])} components={{ bold: <strong />, br: <br /> }} />
            </Card>
          </a>
        ))}
      </div>
    </div>
  );
};

export default AgencyServicesCards;
